import { getEnvironmentVariableByName } from "../../utils/";
import { useTheme } from "@mui/material";
import { useCallback, useEffect, useMemo } from "react";

const scriptElementId = "Microsoft_Omnichannel_LCWidget";
const dataAppId = getEnvironmentVariableByName("CHATBOT_DATA_APP_ID");
const dataOrgId = getEnvironmentVariableByName("CHATBOT_DATA_ORG_ID");
const dataOrgUrl = getEnvironmentVariableByName("CHATBOT_DATA_ORG_URL");
const bootstrapSource =
  "https://oc-cdn-public-eur.azureedge.net/livechatwidget/scripts/LiveChatBootstrapper.js";

export const useChatBotScript = () => {
  const theme = useTheme();
  const attributes: Record<string, string> = useMemo(
    () => ({
      id: scriptElementId,
      src: bootstrapSource,
      "data-app-id": dataAppId,
      "data-lcw-version": "prod",
      "data-org-id": dataOrgId,
      "data-org-url": dataOrgUrl,
      "data-hide-chat-button": "true",
      InstrumentationKey: "key",
      "data-color-override": theme.palette.primary.main,
      v2: "",
    }),
    [theme.palette.primary.main],
  );

  const initChatBot = useCallback(() => {
    if (!document.getElementById(scriptElementId)) {
      const chatBot = document.createElement("script");
      Object.keys(attributes).forEach(key =>
        chatBot.setAttribute(key, attributes[key]),
      );
      document.body.appendChild(chatBot);
    }
  }, [attributes]);

  const startChat = () => {
    window?.Microsoft?.Omnichannel?.LiveChatWidget?.SDK?.startChat();
  };

  const endChat = () => {
    window?.Microsoft?.Omnichannel?.LiveChatWidget?.SDK?.endChat();
  };

  useEffect(() => {
    initChatBot();
  }, [initChatBot]);

  return {
    initChatBot,
    startChat,
    endChat,
  };
};
